import authn from "./services/authn"
export {getDiscoveryService, makeDiscoveryServices} from "./utils"

const discovery = {
  authn,
}

export {discovery}
